import { useState, useEffect, useRef } from 'react';
import { OnboardingModal, OnboardingForm } from '../components/ui/OnboardingModal';
import GameService from "../services/GameService";

const UserCheck = ({ walletAddress, onUserFound }) => {
  const [showModal, setShowModal] = useState(false);
  const checkLockRef = useRef(false);
  const gameServiceRef = useRef(null);
  
  if (!gameServiceRef.current) {
    gameServiceRef.current = new GameService(process.env.REACT_APP_API_URL || '');
  }
 
  useEffect(() => {
    if (!walletAddress || checkLockRef.current) return;

    const abortController = new AbortController();
    let isCurrentCall = true;
    checkLockRef.current = true;

    const checkUser = async () => {
      try {
        // Set wallet address in GameService before checking
        gameServiceRef.current.setWalletAddress(walletAddress);
        // Use gameServiceRef.current instead of gameService
        const data = await gameServiceRef.current.checkUser(walletAddress);
        
        if (!isCurrentCall) {
          return;
        }

        if (data) {
          onUserFound({
            ...data,
            wallet_address: walletAddress
          });
          setShowModal(false);
        } else {
          onUserFound(null);
          setShowModal(true);
        }
      } catch (error) {
        if (!isCurrentCall) return;
        console.error('Error checking user:', error);
        onUserFound(null);
      } finally {
        if (isCurrentCall) {
          checkLockRef.current = false;
        }
      }
    };

    checkUser();

    return () => {
      isCurrentCall = false;
      abortController.abort();
      checkLockRef.current = false;
    };
  }, [walletAddress, onUserFound]);

  // Reset when wallet is cleared
  useEffect(() => {
    if (!walletAddress) {
      setShowModal(false);
      checkLockRef.current = false;
      onUserFound(null);
    }
  }, [walletAddress, onUserFound]);
 
  if (!walletAddress) {
    return null;
  }
  
  return (
    <OnboardingModal 
      isOpen={showModal} 
      onClose={() => setShowModal(false)}
    >
      <OnboardingForm 
        walletAddress={walletAddress} 
        onComplete={(userData) => {
          setShowModal(false);
          onUserFound({
            ...userData,
            wallet_address: walletAddress
          });
        }} 
      />
    </OnboardingModal>
  );
};

export default UserCheck;